export default __webpack_public_path__ + "static/media/tipImg.c6f5e03d.jpeg";